
// require('bulma-extensions/bulma-accordion/dist/bulma-accordion');
// require('bulma-extensions/bulma-carousel/dist/bulma-carousel');
// require('bulma-extensions/bulma-iconpicker/dist/bulma-iconPicker');
//var bulmaQuickview = require('bulma-extensions/bulma-quickview/dist/js/bulma-quickview');
//require('bulma-extensions/bulma-slider/dist/js/bulma-slider');
//require('bulma-extensions/bulma-steps/dist/js/bulma-steps');
//require('bulma-extensions/bulma-tagsinput/dist/js/bulma-tagsinput');

//bulmaQuickview.attach();

// make it global, to allow usage in vue js template too
window.bulmaCalendar = require('../../node_modules/bulma-extensions/bulma-calendar/dist/js/bulma-calendar.js');
